
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Fluid_in_the_tympanum',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Fluid_in_the_tympanum.vue